import { useMemo } from 'react';
import { Key, useSWRConfig } from 'swr';

/** @deprecated */
export const useIsCached = (swrKey: Key) => {
  const { cache } = useSWRConfig();
  const isCached = useMemo(() => (swrKey ? !!cache.get(swrKey as string)?.data : false), [cache, swrKey]);
  return isCached;
};
